import React, { useRef } from "react";
import './landing.css';
import Carousel from '../carouselvideo/Carousel.jsx';
import Cards from "../Cards/Cards.jsx";
import News from "../news/News.jsx";
import UsSection from "../Us/UsSection.jsx";
import Footer from "../footer/Footer.jsx";
import Circle from "../circle/circleDinamic.jsx"; // nuestro nuevo componente

export default function Landing() {
  const usRef = useRef(null);
  const footerRef = useRef(null);


  return (
    <div className="main-section">
      <div className="d-flex row">
        <Carousel />
      </div>

      <div className="container-cards">
        <div className="row">
          <Cards />
        </div>
      </div>

      <div className="container">
        <News />
      </div>

     {/* Wrapper de UsSection */}
     <div className="us-section-wrapper" ref={usRef}>

      <Circle triggerRef={usRef}  footerRef={footerRef}/>

      <UsSection />
     </div>
      <div>
        <hr />
      </div>


      <Footer ref={footerRef} /> 

    </div>
  );
}
